"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requireModelCard = requireModelCard;
const anthropic_model_cards_1 = require("./anthropic-model-cards");
const open_ai_model_cards_1 = require("./open-ai-model-cards");
function requireModelCard(model) {
    const card = [...anthropic_model_cards_1.anthropicModelCards, ...open_ai_model_cards_1.openAiModelCards].find((candidate) => String(candidate.model) === model);
    if (card === undefined) {
        throw new Error(`RequireModelCard_UnsupportedModel:${model}`);
    }
    return card;
}
//# sourceMappingURL=require-model-card.js.map